import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import agent from '../agent';
import { isApiError } from '../../common/utils';
import _ from 'lodash';
import axios from 'axios';

// Async thunk for retrying available delivery dates
export const retryAvailableDeliveryDates = createAsyncThunk(
  'deliveryDates/retryAvailableDeliveryDates',
  async (scheduleDeliveryDate, thunkApi) => {
    try {
      const response = await agent.requests.post(
        `/retry-available-delivery-dates?schedule_delivery_date=${scheduleDeliveryDate}`
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const initialState = {
  status: 'idle',
  loading: false,
  error: null,
  retryAvailableDeliveryDatesResponse: {},
};

const deliveryDatesSlice = createSlice({
  name: 'deliveryDates',
  initialState,
  reducers: {
    resetStatus: (state) => {
      state.status = 'idle';
      state.error = null;
      state.retryAvailableDeliveryDatesResponse = {};
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(retryAvailableDeliveryDates.pending, (state) => {
        state.status = 'retryAvailableDeliveryDates/loading';
        state.loading = true;
      })
      .addCase(retryAvailableDeliveryDates.fulfilled, (state, action) => {
        state.status = 'retryAvailableDeliveryDates/success';
        state.retryAvailableDeliveryDatesResponse = action.payload;
        state.loading = false;
      })
      .addCase(retryAvailableDeliveryDates.rejected, (state, action) => {
        state.status = 'retryAvailableDeliveryDates/failed';
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { resetStatus, setLoading } = deliveryDatesSlice.actions;

// Selectors
export const loadingDeliveryDatesStatus = (state) => state.deliveryDates.status;
export const getRetryAvailableDeliveryDatesResponse = (state) =>
  state.deliveryDates.retryAvailableDeliveryDatesResponse;
export const deliveryDatesError = (state) => state.deliveryDates.error;

export default deliveryDatesSlice.reducer;